export default "__VITE_ASSET__Djksgtjv__"